//

//import React, {ChangeEvent, useState, useEffect} from "react";
import React,{useState, useReducer} from "react";
import './quickacces.scss';
import {stickynoteobj} from '../../Entity/stickynoteobj';
import StickynoteItem from "./stickyitem";
import { Helper } from "../../Utils/Helper";
import { Language } from "../../Utils/Language";
interface Props {
  //Notes:Array<stickynoteobj>
  fnGetNotes;
  fnUpdateNote;
  NoteList;
  CacheNote;
  culture
}

const StickyNoteList: React.FC<Props> = (props) => {    
    //const [notelist, setNoteList] = useState<Array<stickynoteobj>>(props.Notes);
    const initialState = {
        //lastNoteCreatedAt: null,
        //totalNotes: 0,
        notes:props.NoteList
      }
      //const [notecount, setNoteCount] = useState<number>(initialState.notes.length);
    let noteitem:stickynoteobj;
    
    const dragOver = (event) => {
        event.stopPropagation();
        event.preventDefault();
       
    }
    const notesReducer = (prevState, action) => {
        switch(action.type){
          case 'ADD_NOTE':
            const newNote = {
              notes:[...prevState.notes, action.payload]
            }
            props.CacheNote(newNote.notes);
            return newNote;
            case 'Update_NOTE':

                return prevState;
            case 'Delete_NOTE':
                let newlist=prevState.notes.filter((l)=>{return l.ID!=action.payload.ID});
                const AfterDeleteNote = {
                    //lastNoteCreatedAt: new Date().toTimeString().slice(0,8),
                    //totalNotes:prevState.notes.length +1,
                    notes:newlist
                    }
                    props.CacheNote(AfterDeleteNote.notes);
                return AfterDeleteNote;
                case 'Load_FromWeb':
                    props.CacheNote(action.payload);
                    const newNotes = {
                        notes:action.payload,
                        checkedInWeb:true
                      }
                      return newNotes;
                
          default:
          return prevState;
        }
      }
     
      const [noteState, dispatch] = useReducer(notesReducer,initialState)
    const AddNewNote=()=>{
        noteitem = {
            ID: Helper.newguid(),
            body: "",
            rotate: Math.floor(Math.random()*20),
            color:"#c4c2bb",
            duedate:new Date(),
            left:0,
            top:0,
            heading:"",
            fontcolor:'#000',
            LastUpdate:new Date()
          };
          noteitem.top =20+(1.2*noteitem.rotate);
          dispatch({ type:'ADD_NOTE', payload:noteitem})
          /* notelist.push(noteitem);          
          setNoteList(notelist);
          setNoteCount(notelist.length) */
    }
    const UpdateList=(action,note)=>{
        let fordelete=false;
        if(action=='Delete_NOTE'){
            fordelete=true;
            dispatch({ type:action, payload:note});
        }
        note.LastUpdate=new Date();
        props.fnUpdateNote(note,fordelete);
    }
    const [calledfromWeb, setCalledFromWeb] = useState<boolean>(false);    
    if(calledfromWeb==false && noteState.notes.length==0){
        setCalledFromWeb(true);
        props.fnGetNotes((successres)=>{            
            if(successres && successres.data && successres.data.IsSuccess){
                dispatch({ type:'Load_FromWeb', payload:successres.data.data})
            }
           })
    }    
    let noteblock=[];
    let notelist=noteState.notes;
    
    Helper.SortList(notelist,'LastUpdate',false,true);
    notelist.forEach((note,index)=>{
        noteblock.push(<StickynoteItem Note={note} key={note.ID} UpdateList={UpdateList}></StickynoteItem>);
    });
    //let marginval=window.window.innerWidth<500 || window.innerHeight<500?"-37px":"-83px";
    return (
        <div className="stickynotlistcontainer" onDragOver={dragOver} ref={(el)=>{
            /*
            bottom: 120
height: 0
left: 548.328125
right: 1314.984375
top: 120
width: 766.65625
x: 548.328125
y: 120
           
           if(el){
               let b=el.getBoundingClientRect();
            parentx=b.left;
            parenty=b.top;
           } */
            
            }} >
            <span onClick={AddNewNote} className="newnoteaction linkbutton">
                <i className="ms-Icon ms-Icon--AddNotes "></i>
                {Language.GetLanguageValue(props.culture,'addnote')}
            </span>
            
        <div>
        {noteblock.length>0? noteblock:(<div className="emptymessageblock notepossitionForlg">Click on Add Note action to creata a new note.</div>)}
        
        </div>
        </div>
       
    )
};

export default StickyNoteList;